export default {"src":"/_next/static/media/dietbon-violet.aee51538.svg","height":26,"width":139,"blurWidth":0,"blurHeight":0};